import { Component, OnInit, Input } from '@angular/core';
import { ArtistDetailModel } from '../../../models/artist';

@Component({
    selector: 'component-contest-artist',
    templateUrl: './contest.artist.component.html'
})

export class ContestArtistComponent implements OnInit {
    @Input() artist: ArtistDetailModel = new ArtistDetailModel();

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/components/contest/artist/contest.artist.component.ts